export default "__VITE_PUBLIC_ASSET__3e0d57fd__"